export default __webpack_public_path__ + "static/media/IMG_2.c4946b37.png";